import ButtonTrigger from 'components/button-trigger';
import callbackCall from 'components/form/config/call';
import Form from 'components/form';
import Header from 'components/header';
import Observer from 'common/scripts/observer';
import PageReveal from 'components/page-reveal';
import Popup from 'components/popup';
import Select from 'components/forms/select';
import TextAccordion from 'components/accordion/textAccordion';
import Utils from 'common/scripts/utils';

const observer = new Observer();

// Поведение шапки
export const initHeader = (headerWrap) => {
    const targetScroll = document.querySelector('.j-first-screen-bg');
    const header = new Header();

    header.init({
        headerWrap,
        targetScroll
    });
};

// Поведение меню
export const initMobileMenu = (burgerMenuSelector, headerWrap) => {
    const menuTrigger = new ButtonTrigger();
    const mobileMenu = headerWrap.querySelector('.navigation-mobile');

    menuTrigger.init({
        target    : burgerMenuSelector,
        eventOpen : 'showMenuTrigger',
        eventClose: 'closeMenuTrigger'
    });

    observer.subscribe('showMenuTrigger', () => {
        headerWrap.classList.add('is-open-menu');
        Utils.bodyFixed(mobileMenu);
    });

    observer.subscribe('closeMenuTrigger', () => {
        headerWrap.classList.remove('is-open-menu');
        Utils.bodyStatic();
    });

    observer.subscribe('scrollbyStart', () => {
        headerWrap.classList.remove('is-open-menu');
        Utils.bodyStatic();
    });
};

// Попапы обратной связи
export const initCallbackPopups = (popupLinks) => {
    const links = popupLinks.filter((link) => {
        return !link.hasAttribute('data-init');
    });

    const popupOptions = {
        openButtons         : links,
        closeButtonAriaLabel: 'Закрыть форму обратной связи',
        template            : 'classic',
        templateContent     : 'action',
        openLoadPage        : false
    };

    const popupCallback = new Popup(popupOptions);

    popupCallback.init();
};

// Попапы машиноместа
export const initParkingPopups = (popupLinks) => {
    const popupOptions = {
        openButtons         : popupLinks,
        closeButtonAriaLabel: 'Закрыть форму обратной связи',
        template            : 'classic',
        templateContent     : 'action',
        openLoadPage        : false
    };

    const popupCallback = new Popup(popupOptions);

    popupCallback.init();
};

// Инциализация формы обратной связи
export const initCallbackForm = () => {
    observer.subscribe('createPopup', (popup, instance) => {
        const callbackSelector = popup.querySelector('.j-form-callback');

        if (callbackSelector) {
            const form = new Form();
            const select = new Select();
            const callbackSelect = callbackSelector.querySelector('.j-select');

            select.init({
                element      : callbackSelect,
                disableSearch: true
            });

            callbackCall(form, callbackSelector, instance);

            observer.subscribe('successForm', () => {
                // Закрываем попап через 3сек
                const send = setTimeout(() => {
                    observer.publish('sendForm', instance);
                }, 3000);

                // Если попап был закрыт ранее через кнопку, то обнуляем интервал.
                observer.subscribe('closePopup', () => {
                    clearTimeout(send);
                });
            });
        }
    });
};

// При открытии попапа сдвигаем шапку на ширину сколл-бара.
export const fixPopupHeader = (headerWrap) => {
    if (!headerWrap) {
        return;
    }

    observer.subscribe('showPopup', () => {
        const body = document.body;

        setTimeout(() => {
            headerWrap.style.paddingRight = getComputedStyle(body).paddingRight;
        });
    });

    observer.subscribe('closePopup', () => {
        headerWrap.style.paddingRight = '0';
    });
};

// Анимация появления блоков
export const initPageReveal = (options) => {
    new PageReveal().init(options);
};


export const videoTrigger = (item) => {
    if ('IntersectionObserver' in window) {
        const eventObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    item.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                }
            });
        });

        eventObserver.observe(item);
    }
};

export const initTextAccordion = (wrapper) => {
    const textAccordion = new TextAccordion();

    textAccordion.init(wrapper);
};

// ловит и сохраняет в сессию utm-метки из урла, чтобы таскать их при переходе по страницам
export const putUtmsToStorage = () => {
    const utms = Array
        .from(new URL(window.location.href).searchParams)
        .filter((n) => {
            return n[0].startsWith('utm_');
        })
        .reduce((acc, n) => ({...acc, [n[0]]: n[1]}), {});

    if (Object.keys(utms).length === 0) {
        return;
    }

    Object.entries(utms).forEach(([key, value]) => {
        window.sessionStorage.setItem(key, value);
    });
};
